import { render, staticRenderFns } from "./orderFreeDialog.vue?vue&type=template&id=2ccfbe5b&scoped=true&"
import script from "./orderFreeDialog.vue?vue&type=script&lang=js&"
export * from "./orderFreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderFreeDialog.vue?vue&type=style&index=0&id=2ccfbe5b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfbe5b",
  null
  
)

export default component.exports